<template>
  <div class="courierApply">
    <div class="formDiv">
      <div class="item">
        <div class="icon ico ico-user"></div>
        <el-input v-model="userinfo.fullname" placeholder="请输入姓名"></el-input>
      </div>
      <div class="item">
        <div class="icon ico ico-phone"></div>
        <el-input type="tel" v-model="userinfo.phone" placeholder="请输入手机号"></el-input>
      </div>
      <div class="item">
        <div class="icon ico ico-idCard"></div>
        <el-input v-model="userinfo.idcard" placeholder="身份证号"></el-input>
      </div>
      <div class="item">
        <div class="icon ico ico-building"></div>
        <el-input v-model="userinfo.company" placeholder="所属快递公司"></el-input>
      </div>
    </div>
    <el-button type="primary" class="submitBtn" @click="submitInfo">提交申请</el-button>
  </div>
</template>
<script>
import { showToast } from '../../../../static/js/utility/utility'
import axios from 'axios'
import * as config from '../../../../static/js/config.js'

export default {
  name:'courierApply',
  data(){
    return {
      userinfo:{
        fullname:'',//姓名
        phone:'',//手机号
        idcard:'',//身份证号
        company:'',//所属快递公司
      }
    }
  },
  created(){
    
  },
  mounted(){

  },
  methods:{
    //提交
    submitInfo(){
      let that = this
      if(this.userinfo.fullname==''){
        showToast('请输入姓名！')
        return
      }
      let rePhone = new RegExp(/^1[3|4|5|7|8|9][0-9]\d{8}$/)
      if(this.userinfo.phone==''){
        showToast('请输入手机号码！')
        return
      }else if (!rePhone.test(this.userinfo.phone)) {
        showToast('请输入正确的手机号码')
        return
      }
      let reCard = new RegExp(/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)
      if(this.userinfo.idcard==''){
        showToast('请输入身份证号！')
        return
      }else if (!reCard.test(this.userinfo.idcard)) {
        showToast('请输入正确的身份证号')
        return
      }
      if(this.userinfo.company==''){
        showToast('请输入所属公司！')
        return
      }
      const dataObj = {
        'info': that.$route.query.info,//公司id
        'user_name': that.userinfo.fullname,//姓名
        'phone_no': that.userinfo.phone,//手机号码
        'identity': that.userinfo.idcard,//身份证
        'express_company': that.userinfo.company,//所属公司
      }
      axios({
        url: config.commonAddress + "/common/Courier/addCompanyCourier",
        method: "post",
        data: dataObj,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function(res) {
        // console.log(res)
        if(res.data.meta.code == 200){
          that.$router.push({
            path:'/courierStatus',
            query:{
              type:'1',//1提交申请，2申请通过，3申请不通过
            }
          })
        }else{
          showToast(res.data.meta.message)
        }
      })

    }
  },
  components:{
    // Field,
  },
  watch:{

  }
}
</script>
<style lang="scss">
.courierApply{
  background: #f2f2f2;
  height: 100vh;
  padding-top: 0.2rem;
  box-sizing: border-box;
  .formDiv{
    border-top: 0.01rem solid #ddd;
    .item{
      background: #fff;
      display: flex;
      align-items: center;
      padding: 0.2rem;
      font-size: 0.4rem;
      border-bottom: 0.01rem solid #ddd;
      .icon{
        color: #666;
        font-size: 0.36rem;
      }
      .el-input{
        font-size: 0.3rem;
        .el-input__inner{
          border: none;
          height: 0.4rem;
          line-height: 0.4rem;
        }
      }
    }
  }
  .submitBtn{
    display: block;
    width: 80%;
    margin: 1rem auto 0;
    font-size: 0.3rem;
    padding: 0.2rem 0.3rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/PhonePage/courierBusiness/courierApply.vue